<template>
  <el-row :gutter="24" class="search-not-found">
    <el-col class="search-not-found__item">
      <span class="search-not-found__title">
        Ничего не найдено
      </span>
      <i class="material-icons">
        search
      </i>
    </el-col>
  </el-row>
</template>

<script>
/*
  Search component "Nothing found"
*/

export default {
  name: "SearchNotFound"
};
</script>

<style>
.search-not-found {
  font-family: "Roboto", "Arial", sans-serif;
  font-size: 14px;
  line-height: normal;
  color: rgba(173, 181, 197, 0.7);
}

.search-not-found__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
}

.search-not-found__title {
  margin-bottom: 10px;
}

.search-not-found .material-icons {
  font-size: 48px;
}
</style>
